import { render, staticRenderFns } from "./xmPoster.vue?vue&type=template&id=68ea9cca&scoped=true"
import script from "./xmPoster.vue?vue&type=script&lang=js"
export * from "./xmPoster.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ea9cca",
  null
  
)

export default component.exports